import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { widgetItemStyle, widgetItemCountStyle, widgetItemTitleStyle } from 'basics/styles/widget.style';
import useCountCiWidget from 'components/CountWidgets/CountCiWidget/CountCiWidget.hook';
import { CountWidgetPropsType } from 'components/CountWidgets/CountWidget.types';
import Loader from 'yoda-ui/components/Loader';
import { YodaColors } from 'yoda-ui/yodaTheme';

const CountCiWidget: FC<CountWidgetPropsType> = ({
  filters,
  useAdminFilters,
}) => {
  const { value, loading } = useCountCiWidget(filters, useAdminFilters);
  const { t } = useTranslation();

  return (
    <Box sx={ widgetItemStyle } >
      <Box sx={ widgetItemTitleStyle }>
        <img src='/dashboard/CI-icon.svg' alt="CI-icon" style={ { height: 'inherit' } } />
        { t('maya_count_ci_widget_label') }
      </Box>
      <Box sx={ widgetItemCountStyle } visibility={ loading ? 'hidden' : 'inherit' }>
        { value !== undefined ? value as number : '-' }
      </Box>
      { loading ? <Loader center size={ 1 } color={ YodaColors.inherit } /> : null }
    </Box>
  );
};

export default CountCiWidget;
